// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.dynamic.form.FormPositionResponse */
/* istanbul ignore next */
@GandalfModel
export class FormPositionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	height!: number | null;

	@GandalfProperty({ designType: Number })
	left!: number | null;

	@GandalfProperty({ designType: Number })
	top!: number | null;

	@GandalfProperty({ designType: Number })
	width!: number | null;

}
